import {
  Box,
  Chip,
  Dialog,
  Divider,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BiAddToQueue } from 'react-icons/bi';
import IDiseaseClassification from '../../../interfaces/IDiseaseClassification';
import DeleteIcon from '@mui/icons-material/Delete';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { sdsGrayscale } from '../../../theme/sds-tokens';
import { useMedicalCertificateService } from '../../../hooks/services/useMedicalCertificateService';
import Transition from '../../followup/FollowupTransition';
import FollowupDiseaseClassificationForm from '../../followup/FollowupDiseaseClassificationForm';

interface IProps {
  medicalCertificateId: string;
}

const MedicalCertificateFormCid = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [diesases, setDiseaes] = useState<IDiseaseClassification[]>([]);
  const [openCidForm, setOpenCidForm] = useState(false);

  const medicalCertificateService = useMedicalCertificateService();

  useEffect(() => {
    listDiseases();
  }, [props.medicalCertificateId]);

  const removeDisease = async (id: string): Promise<void> => {
    setLoading(true);
    medicalCertificateService
      .removeDiseasesClassification(id)
      .then(async () => {
        setLoading(false);
        await listDiseases();
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Ocorreu um erro ao carregar a lista de doenças.');
      });
  };

  const listDiseases = async (): Promise<void> => {
    setLoading(true);
    medicalCertificateService
      .listDiseasesByMedicalCertificateId(props.medicalCertificateId)
      .then(result => {
        setLoading(false);
        setDiseaes(result);
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Ocorreu um erro ao carregar a lista de doenças.');
      });
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        height: '100%',
        mt: 1,
        bgcolor: theme => (theme.palette.mode === 'dark' ? theme.palette.background.paper : sdsGrayscale[10]),
      }}
    >
      <Dialog fullWidth open={openCidForm} TransitionComponent={Transition}>
        <FollowupDiseaseClassificationForm
          closeDialog={() => setOpenCidForm(false)}
          isOpen={openCidForm}
          medicalCertificateId={`${props.medicalCertificateId}`}
          handleRequest={listDiseases}
        />
      </Dialog>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocalHospitalIcon color="error" />
          <Typography variant="h2" component="h2" fontWeight={600}>
            Lista de CIDs
          </Typography>
        </Box>
        <Tooltip title="Adicionar CID" placement="left">
          <IconButton onClick={() => setOpenCidForm(true)}>
            <BiAddToQueue />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ height: 4, mt: 1 }}>{loading ? <LinearProgress /> : <></>}</Box>
      <Divider />
      <List dense={true} sx={{ mt: 1 }}>
        {diesases.map(({ id, description, code }) => (
          <ListItem
            key={id}
            disableGutters
            secondaryAction={
              <Tooltip title="Excluir CID" placement="left">
                <IconButton edge="end" aria-label="delete" onClick={() => removeDisease(`${id}`)}>
                  <DeleteIcon color="error" />
                </IconButton>
              </Tooltip>
            }
            sx={{
              py: 1.25,
              '&:not(:last-of-type)': {
                borderBottom: '1px solid',
                borderColor: 'divider',
              },
            }}
          >
            <Chip
              label={`CID ${code}`}
              size="small"
              sx={{
                mr: 1.5,
                flexShrink: 0,
                fontWeight: 600,
                borderRadius: 1,
                background: '#1a817a',
                color: '#FFFFFF',
              }}
            />
            <Typography variant="body2" noWrap sx={{ minWidth: 0 }}>
              {description}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default MedicalCertificateFormCid;
